import { render, staticRenderFns } from "./CreateChainFromExternal.vue?vue&type=template&id=f055bbbc&scoped=true"
import script from "./CreateChainFromExternal.vue?vue&type=script&lang=js"
export * from "./CreateChainFromExternal.vue?vue&type=script&lang=js"
import style0 from "./CreateChainFromExternal.vue?vue&type=style&index=0&id=f055bbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f055bbbc",
  null
  
)

export default component.exports